import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Force = ({force, name, hasAutomations}) => { 
    const deleteAutomations = useCallback(() => {
        for (let parameter of force) {
            let {mixAutomation, automation} = parameter;
            automation.deleteAutomations();
            mixAutomation.deleteAutomations();
        }
    }, [force]);
    return (
        <div className="script-force">
          {name}
          {hasAutomations ?
           <img
             onClick={deleteAutomations}
             src="/automation-icon-disabled.png" className="automation-icon"/> : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
    let f = props.force;
    let hasAutomations = pAutomations(f[0])
        || pAutomations(f[1])
        || pAutomations(f[2])
        || pAutomations(f[3])
        || mAutomations(f[0])
        || mAutomations(f[1])
        || mAutomations(f[2])
        || mAutomations(f[3])
    ;
    return {
        hasAutomations
    };
};

const pAutomations = (p) => {
    return p.automations && p.automations.length;
};

const mAutomations = (p) => {
    return p.mixAutomation && p.mixAutomation.automations && p.mixAutomation.automations.length;
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Force);
